/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withClient } from 'fierry/react';

import { matchRoute } from 'fierry/util/route';


const UnknownRoute = '/:unknown-route';


export default withClient(class
{
  constructor ({ route, routes })
  {
    const { value, type, args } = matchRoute(route, routes, UnknownRoute);

    this.value = value;
    this.type  = type;
    this.args  = args;
  }


  getType ()
  {
    return this.type;
  }


  getValue ()
  {
    return this.value;
  }


  getArg (key, defaultValue = null)
  {
    return this.args[key] ?? defaultValue;
  }


  isType (type)
  {
    return this.type === type;
  }


  isUnknown ()
  {
    return this.type === UnknownRoute;
  }


});
